import { MovementListPage } from './MovementListPage.js';

/**
 * UI_REFERENCE_SOURCE:
 * section: Sakhtar Inventory.dc.html §02 GOODS RECEIPT
 * archetype: ENTITY_LIST + create form
 * status: KIT_CONFORMANT — real create form (`POST .../inventory/receipts`,
 *   real `inventory.receipt.create` permission). The board's PO-source
 *   picker and order-vs-received discrepancy detection have no backing
 *   data (no purchase-order reference field exists on a receipt line) —
 *   not built; `sourceReference` is a plain free-text field instead.
 * state reference: ready · empty · permission_denied · network_error
 */
export function ReceiptsPage() {
  return (
    <MovementListPage
      endpoint="receipts"
      variant="receipt"
      title="رسید انبار"
      emptyLabel="رسید انباری ثبت نشده"
      emptyDescription="رسید جدید را از فرم بالا برای یک کالا و انبار ثبت کنید."
    />
  );
}
